import { useQuery } from "@tanstack/react-query"
import { API_URL, QUERY_KEYS } from "../constants"

export const useGetSubscription = (token: string, orgId?: string) =>
  useQuery<{ subscription: any; labReportsDownloaded: number }, Error>({
    queryKey: QUERY_KEYS.subscription(orgId!),
    queryFn: async () => {
      if (!orgId) {
        throw new Error("Organization ID is required")
      }
      const res = await fetch(`${API_URL}/organizations/${orgId}/billing/subscription/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (!res.ok) {
        const parsed = await res.json()
        throw new Error(parsed.error ?? parsed.message ?? parsed ?? "Internal Server Error")
      }

      const json = await res.json()
      if (json.error) {
        throw new Error(json.error)
      }

      return json
    },
  })
